import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ProposedCollections from "src/components/blocks/ProposedCollections";
import RecommendedCollections from "src/components/blocks/RecommendedCollections";
import RevisioCollections from "src/components/blocks/RevisioCollections";
import UserFolders from "src/components/blocks/UserFolders";
import Heading from "src/components/typography/Heading";
import { Container, Content } from "src/components/utilities/Containers";
import { LoadingContext, UserContext } from "src/context";
export var FOLDERS_LIMIT = 6;
function DashboardContent(_a) {
    var _b, _c, _d;
    var dataRecommendations = _a.dataRecommendations, dataProposedCollections = _a.dataProposedCollections, dataSubscriptions = _a.dataSubscriptions, dataRevisio = _a.dataRevisio;
    var t = useTranslation().t;
    var removeLoading = useContext(LoadingContext).removeLoading;
    useEffect(function () {
        removeLoading();
    }, [removeLoading]);
    var revisioData = dataRevisio === null || dataRevisio === void 0 ? void 0 : dataRevisio.collectionsAvailableInRevisio;
    var hasRevisioSection = ((_c = (_b = revisioData === null || revisioData === void 0 ? void 0 : revisioData.results) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
    var currentUser = useContext(UserContext);
    return (React.createElement(Container, { css: "padding-bottom: 3rem;" },
        React.createElement(Content, { pt: 2 },
            React.createElement(Heading, { fontSize: ["1.6rem", "1.6rem", "2.6rem"], textAlign: ["center", "center", "left"] },
                t("welcome"),
                " ",
                currentUser.firstname)),
        (dataRecommendations === null || dataRecommendations === void 0 ? void 0 : dataRecommendations.collections) &&
            dataRecommendations.collections.results &&
            dataRecommendations.collections.results.length > 0 && (React.createElement(RecommendedCollections, { collections: dataRecommendations.collections.results })),
        (dataProposedCollections === null || dataProposedCollections === void 0 ? void 0 : dataProposedCollections.proposedCollections) &&
            dataProposedCollections.proposedCollections.results &&
            dataProposedCollections.proposedCollections.results.length > 0 && (React.createElement(ProposedCollections, { proposalCollections: dataProposedCollections.proposedCollections
                .results })),
        hasRevisioSection && (revisioData === null || revisioData === void 0 ? void 0 : revisioData.results) && (React.createElement(RevisioCollections, { results: revisioData.results, count: revisioData.count })),
        (dataSubscriptions === null || dataSubscriptions === void 0 ? void 0 : dataSubscriptions.folders) &&
            dataSubscriptions.folders.results &&
            dataSubscriptions.folders.results.length > 0 && (React.createElement(UserFolders, { folders: dataSubscriptions.folders.results, showLinkButton: ((_d = dataSubscriptions.folders.count) !== null && _d !== void 0 ? _d : 0) > FOLDERS_LIMIT }))));
}
export default DashboardContent;
